import Http from '@/api/http.js'

export default {

  profile() {
    let base = process.env.VUE_APP_API_BASE || "/"
    // console.log({base});
    return Http({ url: '/auth/user_profile', baseURL: base })
    // return Http.get('/users/profile')
    // return Http.get(`/wholesale_trucks`)
  },
}